<template>
  <div v-if="visible" class="context">
    <div class="example card text-center mb-3">
      <div class="card-body">
        {{ t('result.context.context-example') }}
        <b>{{ result.example }}</b>
        {{ t('result.context.previous-list') }}
      </div>
    </div>
    <div v-if="documentHeader" class="document-header card mb-3 p-3">
      <ncs-context-document-header :document="result.document" :text="result.match.text"/>
    </div>
    <a class="btn btn-primary btn-sm my-3" v-if="before < 20" @click.prevent="before += 10" href="#">
      <i class="fa fa-plus"/>
    </a>
    <ul v-if="result.before.length > 0" class="texts-before list-group">
      <li v-for="text in textsBefore" class="context-text list-group-item">
        <ncs-context-text :document="result.document" :text="text"/>
      </li>
    </ul>
    <ul class="texts-text-match list-group my-3">
      <li class="context-text list-group-item bg-lightblue">
        <ncs-context-text :document="result.document" :text="result.match" :analysis="true"/>
      </li>
    </ul>
    <ul v-if="result.after.length > 0" class="texts-after list-group">
      <li v-for="text in textsAfter" class="context-text list-group-item">
        <ncs-context-text :document="result.document" :text="text"/>
      </li>
    </ul>
    <a class="btn btn-primary btn-sm my-3" v-if="after < 20" @click.prevent="after += 10" href="#">
      <i class="fa fa-plus"/>
    </a>
  </div>
</template>
<script setup lang="ts">
import { ref, computed, defineComponent } from 'vue'
import { useNcsConfig, useApiStore, useNcsI18n, ContextResult } from 'ncs'

const { t } = useNcsI18n()
const ncsConfig = useNcsConfig()
const apiStore = useApiStore()

const { documentHeader } = ncsConfig.queries.context
const result = computed(() => apiStore.response as ContextResult)
const visible = computed(() => apiStore.query?.type === 'context')

const before = ref(2)
const after = ref(2)

const textsBefore = computed(() => result.value.before.slice(-before.value))
const textsAfter = computed(() => result.value.after.slice(0, after.value))
</script>
